import spActivitiesTemplate from './spactivities.html';

const { format } = require('date-fns');

angular
   .module('org.saga.widget.spactivities', [
      'org.saga.service',
      'org.saga.newspactivity',
      'org.saga.spprioritycomment',
      'org.saga.newspbudgetitem',
      'org.saga.spcosts'
   ])
   .directive('spactivitiesWidget', [
      'PropertiesLoader',
      '$translate',
      'InstanceExpression',
      'SpActivities',
      'SpComments',
      'SpBudgetItems',
      function (
         PropertiesLoader,
         $translate,
         InstanceExpression,
         SpActivities,
         SpComments,
         SpBudgetItems
      ) {
         return {
            restrict: 'E',
            require: '^form',
            controllerAs: 'ctrl',
            template: spActivitiesTemplate,
            scope: {
               widget: '=',
               editable: '=',
               instance: '=',
               required: '=',
               activities: '=?',
               budgetitems: '=?',
               lastcommentid: '=?'
            },
            controller: [
               '$scope',
               '$parse',
               '$mdDialog',
               'DefaultProperties',
               'NewSpActivityDialog',
               'SpPriorityCommentDialog',
               'NewSpBudgetItemDialog',
               function (
                  $scope,
                  $parse,
                  $mdDialog,
                  DefaultProperties,
                  NewSpActivityDialog,
                  SpPriorityCommentDialog,
                  NewSpBudgetItemDialog
               ) {
                  PropertiesLoader.load($scope, DefaultProperties.spactivities);
                  $scope.loading = false;

                  function getValueFromAttribute(attribute) {
                     return InstanceExpression.eval(attribute, $scope.instance);
                  }

                  $scope.processId = getValueFromAttribute($scope.processId);
                  $scope.socialPartnerId = getValueFromAttribute($scope.socialPartnerId);
                  $scope.commentCreatorEmail = getValueFromAttribute($scope.commentCreatorEmail);
                  $scope.commentCreatorName = getValueFromAttribute($scope.commentCreatorName);
                  $scope.commentCreatorDepartment = getValueFromAttribute(
                     $scope.commentCreatorDepartment
                  );
                  $scope.totalPersonalCosts = getValueFromAttribute($scope.totalPersonalCosts);
                  $scope.totalOperatingCosts = getValueFromAttribute($scope.totalOperatingCosts);

                  $scope.personalCosts = [];
                  $scope.operatingCosts = [];
                  $scope.personalCostsLeft = 0;
                  $scope.operatingCostsLeft = 0;

                  function filterCostsByType(budgetItems, type) {
                     return budgetItems
                        .filter((bi) => bi.budgetType === type)
                        .reduce((acc, bi) => {
                           if (!acc[bi.activityId]) {
                              acc[bi.activityId] = [];
                           }
                           acc[bi.activityId].push(bi);
                           return acc;
                        }, {});
                  }

                  function calculateCostsByType(costs, type) {
                     return costs
                        .filter((bi) => bi.budgetType === type)
                        .reduce((sum, bi) => sum + Number(bi.costTotal), 0);
                  }

                  function getActivitiesAndBudgetItems() {
                     $scope.loading = true;
                     const params = {
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId
                     };

                     SpActivities.fetch(params)
                        .$promise.then(function (response) {
                           $scope.loading = false;
                           $scope.activities = angular.copy(response.results);
                           $scope.reloadKey = Date.now(); // Force re-render of ng-repeat
                        })
                        .catch(function () {
                           $scope.loading = false;
                           $scope.activities = [];
                        });

                     SpBudgetItems.fetch(params)
                        .$promise.then(function (response) {
                           $scope.budgetitems = angular.copy(response.results);
                           $scope.budgetItemsReloadKey = Date.now();
                           $scope.personalCosts = filterCostsByType(
                              $scope.budgetitems,
                              'PERSONAL_COST'
                           );
                           const currentPersonalCosts = calculateCostsByType($scope.budgetitems, 'PERSONAL_COST')
                           $scope.personalCostsLeft = $scope.totalPersonalCosts - currentPersonalCosts;

                           $scope.operatingCosts = filterCostsByType(
                              $scope.budgetitems,
                              'OPERATING_COST'
                           );
                           const currentOperatingCosts = calculateCostsByType($scope.budgetitems, 'OPERATING_COST')
                           $scope.operatingCostsLeft = $scope.totalOperatingCosts - currentOperatingCosts;
                        })
                        .catch(function () {
                           $scope.budgetitems = [];
                        });
                  }

                  getActivitiesAndBudgetItems();

                  $scope.showAddActivityDialog = function () {
                     NewSpActivityDialog.show(
                        {
                           processId: $scope.processId,
                           socialPartnerId: $scope.socialPartnerId
                        },
                        (activity) => $scope.formatAndSaveActivity(activity)
                     );
                  };

                  $scope.deleteActivity = function (activityId) {
                     SpActivities.delete({ row_id: activityId })
                        .$promise.then(function () {
                           getActivitiesAndBudgetItems();
                        })
                        .catch(function () {
                           showErrorDialog();
                        });
                  };

                  function createUploadData(activity) {
                     return {
                        activityName: activity.activityName,
                        activityFrom: format(activity.activityFrom, 'yyyy-MM-dd'),
                        activityTo: format(activity.activityTo, 'yyyy-MM-dd'),
                        activityDescription: activity.activityDescription,
                        processId: activity.processId,
                        socialPartnerId: activity.socialPartnerId
                     };
                  }

                  function createActivityCopy(activityToCopy) {
                     return angular.copy({
                        activityName: activityToCopy.activityName,
                        activityFrom: new Date(activityToCopy.activityFrom),
                        activityTo: new Date(activityToCopy.activityTo),
                        activityDescription: activityToCopy.activityDescription,
                        processId: activityToCopy.processId,
                        socialPartnerId: activityToCopy.socialPartnerId
                     });
                  }

                  function showErrorDialog() {
                     $mdDialog.show(
                        $mdDialog
                           .alert()
                           .clickOutsideToClose(true)
                           .title('Chyba volání služby')
                           .textContent('Při komunikaci se serverem došlo k chybě. Kontaktujte podporu.')
                           .ok($translate.instant('Ok'))
                     );
                  }

                  $scope.editActivity = function (activity) {
                     const activityId = activity.id;
                     const activityToEdit = createActivityCopy(activity);

                     NewSpActivityDialog.show(activityToEdit, (newActivity) => {
                        const data = createUploadData(newActivity);
                        SpActivities.update({ row_id: activityId }, data)
                           .$promise.then(function () {
                              getActivitiesAndBudgetItems();
                           })
                           .catch(function () {
                              showErrorDialog();
                           });
                     });
                  };

                  $scope.duplicateActivity = function (activityToDuplicate) {
                     const newActivity = createActivityCopy(activityToDuplicate);

                     NewSpActivityDialog.show(newActivity, (activity) =>
                        $scope.formatAndSaveActivity(activity)
                     );
                  };

                  $scope.formatAndSaveActivity = function (activity) {
                     const data = createUploadData(activity);

                     SpActivities.create(data)
                        .$promise.then(function () {
                           getActivitiesAndBudgetItems();
                        })
                        .catch(function () {
                           showErrorDialog();
                        });
                  };

                  $scope.orderDown = function (itemId, index) {
                     $scope.openedPersonalCosts = [];
                     $scope.openedOperatingCosts = [];

                     let rowId, moveBeforeRowId;

                     //check if the item is the last one or penultimate
                     if (index + 2 >= $scope.activities.length) {
                        //move last item before current item instead
                        rowId = $scope.activities[index + 1].id;
                        moveBeforeRowId = itemId;
                     } else {
                        rowId = itemId;
                        moveBeforeRowId = $scope.activities[index + 2].id;
                     }

                     reorderActivities(rowId, moveBeforeRowId);
                  };

                  $scope.orderUp = function (itemId, index) {
                     $scope.openedPersonalCosts = [];
                     $scope.openedOperatingCosts = [];
                     const moveBeforeRowId = $scope.activities[index - 1].id;

                     reorderActivities(itemId, moveBeforeRowId);
                  };

                  function reorderActivities(rowId, moveBeforeRowId) {
                     SpActivities.reorder({ row_id: rowId, moveBeforeRowId: moveBeforeRowId })
                        .$promise.then(function () {
                           getActivitiesAndBudgetItems();
                        })
                        .catch(function (error) {
                           showErrorDialog();
                        });
                  }

                  function getNewCommentForActivity(activity) {
                     return {
                        commentObjectType: 'ACTIVITY',
                        commentObjectId: activity.activityId,
                        linkToActivity: activity.activityId,
                        commentCreatorEmail: $scope.commentCreatorEmail,
                        commentCreatorName: $scope.commentCreatorName,
                        commentCreatorDepartment: $scope.commentCreatorDepartment,
                        commentType: $scope.configuration,
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId
                     };
                  }

                  $scope.addComment = function (activity) {
                     if (
                        !$scope.commentCreatorEmail ||
                        !$scope.commentCreatorName ||
                        !$scope.commentCreatorDepartment
                     ) {
                        console.log(
                           'Missing commentCreatorEmail or commentCreatorName or commentCreatorDepartment, cannot add comment'
                        );
                        return;
                     }

                     const comment = getNewCommentForActivity(activity);
                     SpPriorityCommentDialog.show(
                        null,
                        comment,
                        $scope.configuration,
                        (comment) => {
                           SpComments.create(comment)
                              .$promise.then(function (response) {
                                 $scope.lastcommentid = response.commentId;
                              })
                              .catch(function () {
                                showErrorDialog()
                              });
                        },
                        activity,
                        null
                     );
                  };

                  function uploadNewBudgetItem(budgetItem) {
                     SpBudgetItems.create(budgetItem)
                        .$promise.then(function () {
                           getActivitiesAndBudgetItems();
                        })
                        .catch(function () {
                           showErrorDialog();
                        });
                  }

                  function createNewBudgetItem (type, activity) {
                     return {
                        budgetType: type,
                        activityId: activity.activityId,
                        processId: activity.processId,
                        socialPartnerId: activity.socialPartnerId
                     }
                  }

                  $scope.addPersonalCost = function (activity) {
                     const personalCost = createNewBudgetItem('PERSONAL_COST', activity);

                     NewSpBudgetItemDialog.show(
                        personalCost,
                        $scope.totalPersonalCosts,
                        $scope.personalCostsLeft,
                        activity,
                        (budgetItem) => {
                           uploadNewBudgetItem(budgetItem);
                        }
                     );
                  };

                  $scope.addOperatingCost = function (activity) {
                     const operatingCost = createNewBudgetItem('OPERATING_COST', activity);

                     NewSpBudgetItemDialog.show(
                        operatingCost,
                        $scope.totalOperatingCosts,
                        $scope.operatingCostsLeft,
                        activity,
                        (budgetItem) => {
                           uploadNewBudgetItem(budgetItem)
                        }
                     );
                  };

                  $scope.openedPersonalCosts = [];

                  $scope.openPersonalCosts = function (activityId, index) {
                     $scope.openedPersonalCosts.push(index);
                  };

                  $scope.closePersonalCosts = function (index) {
                     const i = $scope.openedPersonalCosts.indexOf(index);
                     if (i > -1) {
                        $scope.openedPersonalCosts.splice(i, 1);
                     }
                  };

                  $scope.openedOperatingCosts = [];

                  $scope.openOperatingCosts = function (activityId, index) {
                     $scope.openedOperatingCosts.push(index);
                  };

                  $scope.closeOperatingCosts = function (index) {
                     const i = $scope.openedOperatingCosts.indexOf(index);
                     if (i > -1) {
                        $scope.openedOperatingCosts.splice(i, 1);
                     }
                  };

                  function createBudgetItemCopy(budgetItem) {
                     return angular.copy({
                        budgetType: budgetItem.budgetType,
                        activityId: budgetItem.activityId,
                        costType: budgetItem.costType,
                        costName: budgetItem.costName,
                        costRate: Number(budgetItem.costRate),
                        costMonthUnit: Number(budgetItem.costMonthUnit),
                        collectiveSupportingCost: Number(budgetItem.collectiveSupportingCost),
                        processId: budgetItem.processId,
                        socialPartnerId: budgetItem.socialPartnerId,
                     });
                  }

                  function getTotalCostsByType(type) {
                     return type === 'PERSONAL_COST' ? $scope.totalPersonalCosts : $scope.totalOperatingCosts;
                  }

                  function getCostsLeftByType(type) {
                     return type === 'PERSONAL_COST' ? $scope.personalCostsLeft : $scope.operatingCostsLeft;
                  }

                  $scope.editCost = function (cost, activity) {
                     const budgetItemId = cost.id;
                     const budgetItemToEdit = createBudgetItemCopy(cost);
                     const totalCosts = getTotalCostsByType(cost.budgetType);
                     const costsLeft = getCostsLeftByType(cost.budgetType);

                     NewSpBudgetItemDialog.show(budgetItemToEdit, totalCosts, costsLeft, activity, (newBudgetItem) => {
                        SpBudgetItems.update({ row_id: budgetItemId }, newBudgetItem)
                           .$promise.then(function () {
                           getActivitiesAndBudgetItems();
                           })
                           .catch(function () {
                              showErrorDialog();
                           });
                     });
                  };

                  $scope.duplicateCost = function (cost, activity) {
                     const newBudgetItem = createBudgetItemCopy(cost);
                     const totalBudget = getTotalCostsByType(cost.budgetType);
                     const costsLeft = getCostsLeftByType(cost.budgetType);

                     NewSpBudgetItemDialog.show(newBudgetItem, totalBudget, costsLeft, activity, (budgetItem) =>
                        uploadNewBudgetItem(budgetItem)
                     );
                  };

                  $scope.deleteCost = function (costId) {
                     SpBudgetItems.delete({ row_id: costId })
                        .$promise.then(function () {
                        getActivitiesAndBudgetItems();
                     })
                        .catch(function (error) {
                           showErrorDialog();
                        });
                  };

                  $scope.addCommentToBudgetItem = function (budgetItem) {
                     if (
                        !$scope.commentCreatorEmail ||
                        !$scope.commentCreatorName ||
                        !$scope.commentCreatorDepartment
                     ) {
                        console.log(
                           'Missing commentCreatorEmail or commentCreatorName or commentCreatorDepartment, cannot add comment'
                        );
                        return;
                     }

                     const comment = {
                        commentObjectType: 'BUDGET_ITEM',
                        commentObjectId: budgetItem.budgetItemId,
                        linkToBudgetItem: budgetItem.budgetItemId,
                        commentCreatorEmail: $scope.commentCreatorEmail,
                        commentCreatorName: $scope.commentCreatorName,
                        commentCreatorDepartment: $scope.commentCreatorDepartment,
                        commentType: $scope.configuration,
                        processId: $scope.processId,
                        socialPartnerId: $scope.socialPartnerId
                     };
                     SpPriorityCommentDialog.show(
                        null,
                        comment,
                        $scope.configuration,
                        (comment) => {
                           SpComments.create(comment)
                              .$promise.then(function (response) {
                                 $scope.lastcommentid = response.commentId;
                              })
                              .catch(function () {
                                 showErrorDialog()
                              });
                        },
                        null,
                        budgetItem
                     );
                  };
               }
            ]
         };
      }
   ]);
